import styled from "@emotion/styled";

import { useFormatMessage, type FormatMessages } from "@skilitics/localization";

import { CreateCard } from "./CreateCard";
import type { CreateType } from "./types";

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  column-gap: 2.5%;
  row-gap: 20px;
`;

type Props = {
  selected?: CreateType;
  onSelect: (type: CreateType) => void;
  onConfirm: (type: CreateType) => void;
  hidden?: CreateType[];
};

export const CreateCards = ({ selected, onSelect, onConfirm, hidden }: Props) => {
  const formatMessage = useFormatMessage(formatStrings);

  const createCard = (type: CreateType) => (
    <CreateCard
      mediaIconType={type === "activity" ? "ComposedScreens" : "NavGroup"}
      question={formatMessage(`${type}Question`)}
      action={formatMessage(`${type}Action`)}
      selected={selected === type}
      hidden={!!hidden?.includes(type)}
      onSelect={() => onSelect(type)}
      onConfirm={() => onConfirm(type)}
      data-test={`create-${type}-card`}
    />
  );

  return (
    <Container>
      {createCard("activity")}
      {createCard("grouping")}
    </Container>
  );
};

const formatStrings = {
  activityQuestion: {
    en: "Can't find what you need?",
  },
  activityAction: {
    en: "Create Your Own",
  },
  groupingQuestion: {
    en: "Need group logic?",
  },
  groupingAction: {
    en: "Create group",
  },
} satisfies FormatMessages;
